import { render, staticRenderFns } from "./dealData.vue?vue&type=template&id=7ebf91e7&scoped=true"
import script from "./dealData.vue?vue&type=script&lang=js"
export * from "./dealData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ebf91e7",
  null
  
)

export default component.exports